import Router from "./routes";
import ThemeProvider from "./theme";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { ThemeSettings } from "./components/settings";
import SnackbarProvider from "./components/snackbar";
import { useEffect } from "react";
import { createDB } from "./store/offlineDb";
import { LoadingProvider } from "./context/Loading";

function App() {
  useEffect(() => {
    try {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.toLowerCase().includes("iconify")) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((k) => localStorage.removeItem(k));
    } catch (e) {
      console.warn("Iconify cache purge failed:", e);
    }
    createDB();
  }, []);

  if (process.env.NODE_ENV === "production") {
    console.log = () => {
    };
  }

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <SnackbarProvider>
            <LoadingProvider>
              <Router />
            </LoadingProvider>
          </SnackbarProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}

export default App;
